/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import type { Advisor } from "./advisor"
// May contain unused imports in some cases
// @ts-ignore
import type { BankPartnerV2 } from "./bank-partner-v2"
// May contain unused imports in some cases
// @ts-ignore
import type { MuffinPartenaireBancaire } from "./muffin-partenaire-bancaire"
// May contain unused imports in some cases
// @ts-ignore
import type { PdfPreferences } from "./pdf-preferences"

export interface Note {
  structureId: string
  noteId: string
  comment?: string
  commentCr?: string
  numeroVersion: number
  dateCreation: string
  statut: NoteStatutEnum
  conclusion?: string
  modelEco: NoteModelEcoEnum
  noteFinancier?: number
  noteGlobale?: number
  avancementBanque?: NoteAvancementBanqueEnum
  pdfPreferences: PdfPreferences
  /**
   * Legacy date used by Yoda1 -> use noubaPartner instead
   * @deprecated
   */
  partenaireBancaire?: MuffinPartenaireBancaire
  bankPartner?: BankPartnerV2
  /**
   * Legacy date used by Yoda1 -> use projectCommitteeDate instead
   * @deprecated
   */
  dateComite?: string
  projectCommitteeDate?: string
  advisor?: Advisor
  onlyPrime?: boolean
  lifecycle: NoteLifecycleEnum
  commentCrAnterieur?: string
  creationExNihilo?: boolean
  commentReason?: string
  type: NoteTypeEnum
  commentRevelateur?: string
  commentBilanPasse?: string
  lastSyncDate?: string
  noubaProjectId?: number
  isFromMuffin?: boolean
}

export const NoteStatutEnum = {
  EN_COURS: "EN_COURS",
  ABANDON: "ABANDON",
  ATTENTE_DECISION: "ATTENTE_DECISION",
  FINALISEE: "FINALISEE"
} as const

export type NoteStatutEnum = (typeof NoteStatutEnum)[keyof typeof NoteStatutEnum]
export const NoteModelEcoEnum = {
  MARCHAND: "MARCHAND",
  NON_MARCHAND: "NON_MARCHAND",
  HYBRIDE: "HYBRIDE"
} as const

export type NoteModelEcoEnum = (typeof NoteModelEcoEnum)[keyof typeof NoteModelEcoEnum]
export const NoteAvancementBanqueEnum = {
  PAS_DE_CONTACT_OU_DEBUT_DE_LA_DEMANDE_EN_COURS: "PAS_DE_CONTACT_OU_DEBUT_DE_LA_DEMANDE_EN_COURS",
  EN_ATTENTE_REPONSE_DE_LA_BANQUE: "EN_ATTENTE_REPONSE_DE_LA_BANQUE",
  ACCORD_DE_PRINCIPE_ORAL: "ACCORD_DE_PRINCIPE_ORAL",
  ACCORD_ECRIT: "ACCORD_ECRIT",
  REFUS_DE_LA_BANQUE: "REFUS_DE_LA_BANQUE",
  NON_CONCERNE: "NON_CONCERNE"
} as const

export type NoteAvancementBanqueEnum =
  (typeof NoteAvancementBanqueEnum)[keyof typeof NoteAvancementBanqueEnum]
export const NoteLifecycleEnum = {
  EMERGENCE: "EMERGENCE",
  CREATION: "CREATION",
  REPRISE: "REPRISE",
  DEVELOPMENT: "DEVELOPMENT",
  REBOUND: "REBOUND",
  SCALE: "SCALE"
} as const

export type NoteLifecycleEnum = (typeof NoteLifecycleEnum)[keyof typeof NoteLifecycleEnum]
export const NoteTypeEnum = {
  CREATION: "CREATION",
  REPRISE: "REPRISE",
  STRUCTURE_EXISTANTE: "STRUCTURE_EXISTANTE",
  UNDEFINED_CREATION: "UNDEFINED_CREATION"
} as const

export type NoteTypeEnum = (typeof NoteTypeEnum)[keyof typeof NoteTypeEnum]
